<template>
    <button class="uni-button" :class="{disabled}" :disabled="disabled">
        <slot/>
    </button>
</template>

<script>
    export default {
        name: "UniButton",
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
<style scoped lang="scss">
    .uni-button {
        padding: var(--s-s) var(--s-l);
        background: var(--color-primary);
        color: var(--color-white);
        font-weight: bold;
        width: 100%;
        border-radius: var(--radius-default);
        transition: var(--transition-quick);
        user-select: none;
        min-height:48px;

        &:disabled{
            background: var(--color-grey);
        }

        &:hover{
            background: var(--color-primary-light-1);
        }

        &.button--small {
            height: 32px;
            line-height: 14px;
        }

        &.button--extra-small {
            padding: 0 8px;
            min-height: 32px;
        }

        &.button--secondary {
            background: var(--color-primary-light-2);
            color: var(--color-primary);
        }

        &.normal-button{
            background: transparent;
            color: var(--color-primary);
            &:hover{
                background: #ffeae1;
            }
        }
        &.button--warning {
            background: var(--color-warning-light);
            color: var(--color-warning);
        }

        &.disabled {
            background: lightgray;
            cursor: not-allowed;
        }
    }

    @include screen-m {
        .uni-button {
            width: auto;
        }
    }

</style>
